import type { gqlV2 } from '@vrplatform/data';
import { type Maybe, toTitleCase } from '@vrplatform/utils';

import { StatusBadge, type StatusBadgeProps } from '@vrplatform/components';
import type { owner_statement_status_enum } from '@vrplatform/graphql';

type Props = {
  status: Maybe<gqlV2.owner_statement_status_enum>;
};

const OWNER_STATEMENT_STATUS_BADGE_MAP = {
  draft: 'pending',
  inReview: 'review',
  posted: 'posted',
  published: 'success',
  void: 'disabled',
} as const satisfies Record<
  owner_statement_status_enum,
  StatusBadgeProps['status']
>;

export const StatementStatusBadge = ({ status }: Props) => {
  if (!status) return null;

  return (
    <StatusBadge
      label={toTitleCase(status)}
      status={OWNER_STATEMENT_STATUS_BADGE_MAP[status]}
    />
  );
};
